module.exports = __webpack_public_path__ + "static/media/trophy@about.b4bdedb4.png";